import Sidebar from "./components/sidebar/Sidebar";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ModernPageWrapper from "./components/ModernPageWrapper";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import Company from "./pages/company/Company";
import NewCompany from "./pages/newCompany/NewCompany";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import ProductColor from "./pages/productColor/ProductColor";
import ProductGallery from "./pages/productGallery/ProductGallery";
import NewProduct from "./pages/newProduct/NewProduct";
import MaterialList from "./pages/materialList/MaterialList";
import Material from "./pages/material/Material";
import NewMaterial from "./pages/newMaterial/NewMaterial";
import WarrantyList from "./pages/warrantyList/WarrantyList";
import ReturnList from "./pages/warrantyList/ReturnList";
import StockList from "./pages/warrantyList/StockList";
import NewWarranty from "./pages/newWarranty/NewWarranty";
import NewAdmin from "./pages/newAdmin/NewAdmin";
import NewAffiliate from "./pages/newAffiliate/NewAffiliate";
import OrderList from "./pages/orderList/OrderList";
import AffiliateList from "./pages/affiliateList/AffiliateList";
import History from "./pages/history/History";
import DepositHistory from "./pages/history/DepositHistory";
import DepositList from "./pages/depositList/DepositList";
import EcommerceList from "./pages/ecommerceList/EcommerceList";
import SalesReport from "./pages/salesReport/SalesReport";
import Report from "./pages/report/Reporting";
import OrderInsightsReport from "./pages/report/OrderInsightsReport";
import Login from "./pages/login/Login";
import Pos from "./pages/pos/pos";
import Outlet from "./pages/outlet/Outlet";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { performLogout } from "./redux/apiCalls";
import TransactionList from "./pages/transaction/TransactionList";
import ProductReport from "./pages/productReport/ProductReport";
import ProductStatus from "./pages/productStatus/ProductStatus";
import AffiliateReport from "./pages/affiliateReport/AffiliateReport";
import Checklist from "./pages/checkList/CheckList";
import Campaign from "./pages/campaignList/Campaign";
import Transfer from "./pages/transfer/Transfer";
import DeliveryOrder from "./pages/deliveryOrderList/DeliveryOrder";
import DeliveryOrderUpload from "./pages/deliveryOrderUpload/DeliveryOrderUpload";
import CompleteDepositList from "./pages/completeDepositList/CompleteDepositList";
import NewBrand from "./pages/newBrand/newBrand";
import Brand from "./pages/brand/Brand";
import NewCategory from "./pages/newCategory/newCategory";
import Category from "./pages/category/Category";
import TradeIn from "./pages/pos/tradein";
import TradeInList from "./pages/orderList/TradeIn";
import Journal from "./pages/pos/journal";
import Supplier from "./pages/pos/supplier";
import JournalList from "./pages/orderList/Journal";
import SupplierList from "./pages/orderList/Supplier";
import StatementList from "./pages/orderList/StatementList";
import EditOrder from "./pages/pos/editOrder";
import NewVehicle from "./pages/vehicle/vehicle";
import VehicleList from "./pages/vehicle/VehicleList";
import Assets from "./pages/pos/assets";
import NewSupplier from "./pages/newUser/NewSupplier";
import NewJournal from "./pages/newJournal/NewJournal";
import Journals from "./pages/journal/Journal";
import InstallmentRequests from "./pages/installmentRequests/InstallmentRequests";
import Skip50Requests from "./pages/skip50Requests/Skip50Requests";
import Logs from "./pages/logs/Logs";
import NewPurchaseOrder from "./pages/newPurchaseOrder/NewPurchaseOrder";
import PurchaseOrders from "./pages/purchaseOrders/PurchaseOrders";
import ModelReport from "./pages/productReport/ModelReport";
import NewStaff from "./pages/newUser/NewStaff";
import CommissionList from "./pages/commissionList/CommissionList";
import SliderList from "./pages/sliderList/SliderList";
import NewSlider from "./pages/newProduct/NewSlider";
import WarrantyRequestList from "./pages/warrantyList/WarrantyRequestList";
import ReportPageWrapper from "./components/ReportPageWrapper";
import ChangePassword from "./pages/changePassword/ChangePassword";
import PublicSurvey from "./pages/survey/PublicSurvey";
import PublicBlueprint from "./pages/blueprint/PublicBlueprint";

function App() {
    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const drafter = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "drafter"
            : null
    );

    const purchaser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "purchaser"
            : null
    );

    const user = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "user" : null
    );

    const production = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "production"
            : null
    );

    const installer = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "installer"
            : null
    );

    const marketing = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "marketer"
            : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!currentUser) return;
        const loggedInAt = currentUser.loginStamp
            ? new Date(currentUser.loginStamp)
            : null;
        const reloginCutoff = new Date("2026-10-21T00:00:00+08:00");
        if (
            !loggedInAt ||
            Number.isNaN(loggedInAt.getTime()) ||
            loggedInAt < reloginCutoff
        ) {
            performLogout(dispatch);
        }
    }, [currentUser, dispatch]);

    return (
        <div className="globalContainer">
            <Router>
                <Switch>
                    <Route path="/survey/:id">
                        <PublicSurvey />
                    </Route>
                    <Route path="/blueprint/:id">
                        <PublicBlueprint />
                    </Route>
                    <Route exact path="/">
                        {admin ||
                        superadmin ||
                        staff ||
                        manager ||
                        accountant ||
                        user ||
                        outright ||
                        marketing ? (
                            <>
                                {/* <Topbar /> */}
                                <div className="container">
                                    <Sidebar />
                                    {marketing ? (
                                        <div className="mainContent homeMainContent">
                                            <ModernPageWrapper
                                                title="Users"
                                                subtitle="Manage user accounts"
                                            >
                                                <User />
                                            </ModernPageWrapper>
                                        </div>
                                    ) : (
                                        <div className="mainContent homeMainContent">
                                            <ModernPageWrapper
                                                title="Orders"
                                                subtitle="Manage and track all your orders"
                                            >
                                                <OrderList />
                                            </ModernPageWrapper>
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <Login />
                        )}
                    </Route>
                    {(staff ||
                        manager ||
                        admin ||
                        superadmin ||
                        accountant ||
                        outright ||
                        user ||
                        marketing ||
                        purchaser) && (
                        <>
                            {/* <Topbar /> */}
                            <div className="container">
                                <Sidebar />
                                <div className="mainContent">
                                    {!marketing && (
                                        <>
                                            <Route path="/orders">
                                                <ModernPageWrapper
                                                    title="Orders"
                                                    subtitle="Manage and track all your orders"
                                                >
                                                    <OrderList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/order/:productId">
                                                <ModernPageWrapper
                                                    title="Edit Order"
                                                    subtitle="Modify order details"
                                                >
                                                    <EditOrder />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/installmentRequests">
                                                <ModernPageWrapper
                                                    title="Installment Requests"
                                                    subtitle="Manage and approve installment requests"
                                                >
                                                    <InstallmentRequests />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/skip50Requests">
                                                <ModernPageWrapper
                                                    title="Skip 50% Requests"
                                                    subtitle="Manage and approve requests to waive the 50% deposit"
                                                >
                                                    <Skip50Requests />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/logs">
                                                <ModernPageWrapper
                                                    title="Logs"
                                                    subtitle="Review order activity logs and update their status"
                                                >
                                                    <Logs />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/statements">
                                                <ModernPageWrapper
                                                    title="Statements"
                                                    subtitle="View customer statements"
                                                >
                                                    <StatementList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/tradeinlist">
                                                <ModernPageWrapper
                                                    title="Trade-in List"
                                                    subtitle="Manage trade-in transactions"
                                                >
                                                    <TradeInList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/supplierlist">
                                                <ModernPageWrapper
                                                    title="Supplier List"
                                                    subtitle="Manage supplier information"
                                                >
                                                    <SupplierList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/expenseslist">
                                                <ModernPageWrapper
                                                    title="Expenses List"
                                                    subtitle="Track operating expenses"
                                                >
                                                    <JournalList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/completedeposit">
                                                <ModernPageWrapper
                                                    title="Complete Deposits"
                                                    subtitle="View completed deposit transactions"
                                                >
                                                    <CompleteDepositList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/history">
                                                <ModernPageWrapper
                                                    title="Customer History"
                                                    subtitle="View customer transaction history"
                                                >
                                                    <History />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/installments">
                                                <ModernPageWrapper
                                                    title="Installments"
                                                    subtitle="Manage installment payments"
                                                >
                                                    <DepositHistory />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/newJournal">
                                                <ModernPageWrapper
                                                    title="New Journal"
                                                    subtitle="Create a new journal entry"
                                                >
                                                    <NewJournal />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/journals">
                                                <ReportPageWrapper
                                                    title="Installation Journals"
                                                    subtitle="View and manage installation journals"
                                                >
                                                    <Journals />
                                                </ReportPageWrapper>
                                            </Route>
                                            <Route path="/newPurchaseOrder">
                                                <ModernPageWrapper
                                                    title="New Purchase Order"
                                                    subtitle="Create a new purchase order"
                                                >
                                                    <NewPurchaseOrder />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/purchaseOrders">
                                                <ModernPageWrapper
                                                    title="Purchase Orders"
                                                    subtitle="View and manage purchase orders"
                                                >
                                                    <PurchaseOrders />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/deposits">
                                                <ModernPageWrapper
                                                    title="Deposits"
                                                    subtitle="Manage deposit transactions"
                                                >
                                                    <DepositList />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/completeorder">
                                                <ModernPageWrapper
                                                    title="Complete Orders"
                                                    subtitle="View completed e-commerce orders"
                                                >
                                                    <EcommerceList />
                                                </ModernPageWrapper>
                                            </Route>
                                        </>
                                    )}
                                    {(staff ||
                                        manager ||
                                        admin ||
                                        superadmin ||
                                        outright ||
                                        marketing) && (
                                        <>
                                            {!marketing && (
                                                <>
                                                    <Route exact path="/pos">
                                                        <ModernPageWrapper
                                                            title="Point of Sale"
                                                            subtitle="Process sales transactions"
                                                            stepCode="A2"
                                                        >
                                                            <Pos />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route exact path="/tradein">
                                                        <ModernPageWrapper
                                                            title="Trade-in"
                                                            subtitle="Process trade-in transactions"
                                                        >
                                                            <TradeIn />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route
                                                        exact
                                                        path="/operatingexpenses"
                                                    >
                                                        <ModernPageWrapper
                                                            title="Operating Expenses"
                                                            subtitle="Manage operating expenses"
                                                        >
                                                            <Journal />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route exact path="/assets">
                                                        <ModernPageWrapper
                                                            title="Assets"
                                                            subtitle="Manage company assets"
                                                        >
                                                            <Assets />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route exact path="/supplier">
                                                        <ModernPageWrapper
                                                            title="Supplier"
                                                            subtitle="Manage supplier information"
                                                        >
                                                            <Supplier />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                </>
                                            )}
                                            <Route path="/newUser">
                                                <ModernPageWrapper
                                                    title="New User"
                                                    subtitle="Create new user account"
                                                    narrow
                                                    alignLeft
                                                    wide
                                                    compactPadding
                                                >
                                                    <NewUser />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/companies">
                                                <ModernPageWrapper
                                                    title="Companies"
                                                    subtitle="Manage company accounts"
                                                >
                                                    <Company />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/newCompany">
                                                <ModernPageWrapper
                                                    title="New Company"
                                                    subtitle="Create new company account"
                                                    narrow
                                                    alignLeft
                                                    wide
                                                    compactPadding
                                                >
                                                    <NewCompany />
                                                </ModernPageWrapper>
                                            </Route>
                                            {!marketing && (
                                                <>
                                                    <Route path="/newsupplier">
                                                        <ModernPageWrapper
                                                            title="New Supplier"
                                                            subtitle="Add new supplier"
                                                        >
                                                            <NewSupplier />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/deliveryorders">
                                                        <ModernPageWrapper
                                                            title="Delivery Orders"
                                                            subtitle="Manage delivery orders"
                                                        >
                                                            <DeliveryOrder />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                </>
                                            )}
                                            {(manager ||
                                                admin ||
                                                superadmin ||
                                                outright) && (
                                                <>
                                                    <Route path="/warranties">
                                                        <ModernPageWrapper
                                                            title="Warranties"
                                                            subtitle="Manage warranty claims"
                                                        >
                                                            <WarrantyList />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/returns">
                                                        <ModernPageWrapper
                                                            title="Returns"
                                                            subtitle="Manage product returns"
                                                        >
                                                            <ReturnList />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/stocks">
                                                        <ModernPageWrapper
                                                            title="Stocks"
                                                            subtitle="Manage inventory stock"
                                                        >
                                                            <StockList />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/checklist">
                                                        <ModernPageWrapper
                                                            title="Checklist"
                                                            subtitle="Manage checklists"
                                                        >
                                                            <Checklist />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/transfer">
                                                        <ModernPageWrapper
                                                            title="Transfer"
                                                            subtitle="Manage transfers"
                                                        >
                                                            <Transfer />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    <Route path="/commissions">
                                                        <ModernPageWrapper
                                                            title="Commissions"
                                                            subtitle="Manage commission payments"
                                                        >
                                                            <CommissionList />
                                                        </ModernPageWrapper>
                                                    </Route>
                                                    {(admin || outright || purchaser) && (
                                                        <>
                                                            <Route path="/products">
                                                                <ModernPageWrapper
                                                                    title="Products"
                                                                    subtitle="Manage product catalog"
                                                                >
                                                                    <ProductList />
                                                                </ModernPageWrapper>
                                                            </Route>
                                                            <Route path="/newproduct">
                                                                <ModernPageWrapper
                                                                    title="New Product"
                                                                    subtitle="Add new product"
                                                                    narrow
                                                                    alignLeft
                                                                    wide
                                                                    compactPadding
                                                                >
                                                                    <NewProduct />
                                                                </ModernPageWrapper>
                                                            </Route>

                                                            <Route path="/materials">
                                                                <ModernPageWrapper
                                                                    title="Materials"
                                                                    subtitle="Manage material catalog"
                                                                >
                                                                    <MaterialList />
                                                                </ModernPageWrapper>
                                                            </Route>
                                                            <Route path="/newmaterial">
                                                                <ModernPageWrapper
                                                                    title="New Material"
                                                                    subtitle="Add new material"
                                                                    narrow
                                                                    alignLeft
                                                                    wide
                                                                    compactPadding
                                                                >
                                                                    <NewMaterial />
                                                                </ModernPageWrapper>
                                                            </Route>

                                                            <Route path="/newslider">
                                                                <ModernPageWrapper
                                                                    title="New Slider"
                                                                    subtitle="Create new slider"
                                                                >
                                                                    <NewSlider />
                                                                </ModernPageWrapper>
                                                            </Route>

                                                            <Route path="/affiliates">
                                                                <ModernPageWrapper
                                                                    title="Affiliates"
                                                                    subtitle="Manage affiliate partners"
                                                                >
                                                                    <AffiliateList />
                                                                </ModernPageWrapper>
                                                            </Route>

                                                            {(superadmin || manager || outright) && (
                                                                <>
                                                                    <Route path="/admins">
                                                                        <ModernPageWrapper
                                                                            title="Admins"
                                                                            subtitle="Manage admin accounts"
                                                                        >
                                                                            <Outlet />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/newwarranty">
                                                                        <ModernPageWrapper
                                                                            title="New Warranty"
                                                                            subtitle="Create new warranty"
                                                                        >
                                                                            <NewWarranty />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/transactions">
                                                                        <ModernPageWrapper
                                                                            title="Transactions"
                                                                            subtitle="View all transactions"
                                                                        >
                                                                            <TransactionList />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/newadmin">
                                                                        <ModernPageWrapper
                                                                            title="New Admin"
                                                                            subtitle="Create new admin account"
                                                                        >
                                                                            <NewAdmin />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/newbrand">
                                                                        <ModernPageWrapper
                                                                            title="New Brand"
                                                                            subtitle="Add new brand"
                                                                        >
                                                                            <NewBrand />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/newvehicle">
                                                                        <ModernPageWrapper
                                                                            title="New Vehicle"
                                                                            subtitle="Add new vehicle"
                                                                        >
                                                                            <NewVehicle />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/newcategory">
                                                                        <ModernPageWrapper
                                                                            title="New Category"
                                                                            subtitle="Add new category"
                                                                        >
                                                                            <NewCategory />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/sliders">
                                                                        <ModernPageWrapper
                                                                            title="Sliders"
                                                                            subtitle="Manage sliders"
                                                                        >
                                                                            <SliderList />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/warrantyrequests">
                                                                        <ModernPageWrapper
                                                                            title="Warranty Requests"
                                                                            subtitle="Manage warranty requests"
                                                                        >
                                                                            <WarrantyRequestList />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/brands">
                                                                        <ModernPageWrapper
                                                                            title="Brands"
                                                                            subtitle="Manage brands"
                                                                        >
                                                                            <Brand />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/vehicles">
                                                                        <ModernPageWrapper
                                                                            title="Vehicles"
                                                                            subtitle="Manage vehicles"
                                                                        >
                                                                            <VehicleList />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/categories">
                                                                        <ModernPageWrapper
                                                                            title="Categories"
                                                                            subtitle="Manage categories"
                                                                        >
                                                                            <Category />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/campaigns">
                                                                        <ModernPageWrapper
                                                                            title="Campaigns"
                                                                            subtitle="Manage campaigns"
                                                                        >
                                                                            <Campaign />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/productgallery/:productId">
                                                                        <ModernPageWrapper
                                                                            title="Product Gallery"
                                                                            subtitle="Manage product images"
                                                                        >
                                                                            <ProductGallery />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/productstatus/:productId">
                                                                        <ModernPageWrapper
                                                                            title="Product Status"
                                                                            subtitle="Manage product status"
                                                                        >
                                                                            <ProductStatus />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/product/:productId">
                                                                        <ModernPageWrapper
                                                                            title="Product Details"
                                                                            subtitle="View product information"
                                                                        >
                                                                            <Product />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/material/:materialId">
                                                                        <ModernPageWrapper
                                                                            title="Material Details"
                                                                            subtitle="View material information"
                                                                        >
                                                                            <Material />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/deliveryorderupload/:deliveryOrderId">
                                                                        <ModernPageWrapper
                                                                            title="Delivery Order Upload"
                                                                            subtitle="Upload delivery order documents"
                                                                        >
                                                                            <DeliveryOrderUpload />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/productreport">
                                                                        <ModernPageWrapper
                                                                            title="Product Report"
                                                                            subtitle="View product analytics"
                                                                        >
                                                                            <ProductReport />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/modelreport">
                                                                        <ModernPageWrapper
                                                                            title="Model Report"
                                                                            subtitle="View model analytics"
                                                                        >
                                                                            <ModelReport />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                    <Route path="/productcolor/:productId">
                                                                        <ModernPageWrapper
                                                                            title="Product Colors"
                                                                            subtitle="Manage product colors"
                                                                        >
                                                                            <ProductColor />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/affiliatereport">
                                                                        <ModernPageWrapper
                                                                            title="Affiliate Report"
                                                                            subtitle="View affiliate analytics"
                                                                        >
                                                                            <AffiliateReport />
                                                                        </ModernPageWrapper>
                                                                    </Route>
                                                                </>
                                                            )}

                                                            {(superadmin ||
                                                                manager ||
                                                                user ||
                                                                outright ||
                                                                drafter ||
                                                                purchaser ||
                                                                production ||
                                                                installer ||
                                                                marketing ||
                                                                staff) && (
                                                                <>
                                                                    <Route path="/users">
                                                                        <ModernPageWrapper
                                                                            title="Users"
                                                                            subtitle="Manage user accounts"
                                                                        >
                                                                            <User />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    <Route path="/changepassword">
                                                                        <ModernPageWrapper
                                                                            title="Change Password"
                                                                            subtitle="Update your account password"
                                                                            narrow
                                                                        >
                                                                        <ChangePassword />
                                                                        </ModernPageWrapper>
                                                                    </Route>

                                                                    {!marketing && (
                                                                        <>
                                                                            <Route path="/report">
                                                                                <ReportPageWrapper
                                                                                    title="Reports"
                                                                                    subtitle="View system reports"
                                                                                >
                                                                                    <Report />
                                                                                </ReportPageWrapper>
                                                                            </Route>
                                                                            <Route path="/orderinsights">
                                                                                <ReportPageWrapper
                                                                                    title="Order Insights"
                                                                                    subtitle="Completion and expense analysis"
                                                                                >
                                                                                    <OrderInsightsReport />
                                                                                </ReportPageWrapper>
                                                                            </Route>
                                                                            <Route path="/salesreport">
                                                                                <ReportPageWrapper
                                                                                    title="Sales Report"
                                                                                    subtitle="View sales analytics"
                                                                                >
                                                                                    <SalesReport />
                                                                                </ReportPageWrapper>
                                                                            </Route>
                                                                            <Route path="/newaffiliate">
                                                                                <ModernPageWrapper
                                                                                    title="New Affiliate"
                                                                                    subtitle="Add new affiliate"
                                                                                >
                                                                                    <NewAffiliate />
                                                                                </ModernPageWrapper>
                                                                            </Route>
                                                                            <Route path="/newstaff">
                                                                                <ModernPageWrapper
                                                                                    title="New Staff"
                                                                                    subtitle="Add new staff member"
                                                                                    narrow
                                                                                    alignLeft
                                                                                    wide
                                                                                    compactPadding
                                                                                >
                                                                                    <NewStaff />
                                                                                </ModernPageWrapper>
                                                                            </Route>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    
                    {/* Change Password - Accessible to all logged-in users */}
                    {currentUser && (
                        <>
                            <div className="container">
                                <Sidebar />
                                <div className="mainContent">
                                    <Route path="/changepassword">
                                        <ModernPageWrapper
                                            title="Change Password"
                                            subtitle="Update your account password"
                                            narrow
                                        >
                                            <ChangePassword />
                                        </ModernPageWrapper>
                                    </Route>
                                </div>
                            </div>
                        </>
                    )}
                </Switch>
            </Router>
        </div>
    );
}

export default App;
